var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_52547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42578 21C7.81344 21.8914 8.45301 22.6502 9.26593 23.1831C10.0789 23.716 11.0297 23.9999 12.0018 23.9999C12.9738 23.9999 13.9247 23.716 14.7376 23.1831C15.5506 22.6502 16.1901 21.8914 16.5778 21H7.42578Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3918 12.5497L20.6558 6.82666C20.0999 4.82501 18.8912 3.06644 17.2217 1.83016C15.5522 0.593891 13.5175 -0.0492201 11.4407 0.00294028C9.36396 0.0551007 7.36413 0.799543 5.75878 2.11807C4.15342 3.43659 3.03455 5.25362 2.57981 7.28066L1.23181 12.8177C1.05264 13.5534 1.04293 14.3203 1.20342 15.0603C1.3639 15.8004 1.69039 16.4943 2.15823 17.0897C2.62607 17.6852 3.22306 18.1666 3.90412 18.4976C4.58519 18.8287 5.33255 19.0007 6.08981 19.0007H17.6068C18.3875 19.0007 19.1574 18.8179 19.8548 18.4669C20.5522 18.1159 21.1577 17.6065 21.6228 16.9794C22.088 16.3523 22.3998 15.6251 22.5333 14.8558C22.6668 14.0866 22.6184 13.2968 22.3918 12.5497Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_52547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledBellIcon);
export default __webpack_public_path__ + "static/media/filled-bell-icon.dd449daf9d0a1cc25a5a80fb2af77acd.svg";
export { ForwardRef as ReactComponent };